<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {

					divider: {
						name: 'divider',
						separatorActive: false,
						separatorEffect: 'clouds',

						separatorColorsFirst: '#FFF',
						separatorColorsSecond: '#f23a32',
						separatorColorsThird: '#3461c1',
						separatorColorsFourth: '#f461c1',

            separatorValueCustom: false,

            separatorValueFirst : 5,
            separatorValueSecond : 8,
            separatorValueThird : 5,
            separatorValueFourth : 5,

						labelDesc: 'divider',
						callback: function () {

							vm.resources.divider.separatorActive = this.separatorActive;
							vm.element.internal_config.separatorActive = this.separatorActive;

							vm.resources.divider.separatorEffect = this.separatorEffect;
							vm.element.internal_config.separatorEffect = this.separatorEffect;

							vm.resources.divider.separatorColorsFirst = this.separatorColorsFirst;
							vm.element.internal_config.separatorColors.first = this.separatorColorsFirst;

							vm.resources.divider.separatorColorsSecond = this.separatorColorsSecond;
							vm.element.internal_config.separatorColors.second = this.separatorColorsSecond;

							vm.resources.divider.separatorColorsThird = this.separatorColorsThird;
							vm.element.internal_config.separatorColors.third = this.separatorColorsThird;

							vm.resources.divider.separatorColorsFourth = this.separatorColorsFourth;
							vm.element.internal_config.separatorColors.fourth = this.separatorColorsFourth;

              vm.resources.divider.separatorValueCustom = this.custom;
              vm.element.internal_config.separatorColors.custom = this.custom;

              vm.resources.divider.separatorValueFirst = this.value1;
              vm.element.internal_config.separatorColors.value1 = this.value1;

              vm.resources.divider.separatorValueSecond = this.value2;
              vm.element.internal_config.separatorColors.value2 = this.value2;

              vm.resources.divider.separatorValueThird = this.value3;
              vm.element.internal_config.separatorColors.value3 = this.value3;

              vm.resources.divider.separatorValueFourth = this.value4;
              vm.element.internal_config.separatorColors.value4 = this.value4;


							vm.element.panelDividerEffect();

						},
					},


					anchor: {
						name: 'anchor',
						anchorActive: false,
						anchorName: '',
						labelDesc: 'anchor',
						callback: function () {

							vm.resources.anchor.anchorActive = this.anchorActive;
							vm.element.internal_config.anchorActive = this.anchorActive;

							vm.resources.anchor.anchorName = this.anchorName;
							vm.element.internal_config.anchorName = this.anchorName;

							vm.element.config.anchorActive = this.anchorActive;
							vm.element.config.anchorName = this.anchorName;

							this.$root.$emit('updateAnchor', vm.element)
						},
					},
					parallax: {
						name: 'parallax',
						parallaxActive: false,
						parallaxEffect: 'scroll',
						parallaxSpeed: 20,
						labelDesc: 'parallax',
						callback: function () {

							vm.resources.parallax.parallaxActive = this.parallaxActive;
							vm.element.internal_config.parallaxActive = this.parallaxActive;

							vm.resources.parallax.parallaxEffect = this.parallaxEffect;
							vm.element.internal_config.parallaxEffect = this.parallaxEffect;

							vm.resources.parallax.parallaxSpeed = parseFloat(this.parallaxSpeed);
							vm.element.internal_config.parallaxSpeed = parseFloat(this.parallaxSpeed);

						},
					},

          infiniteSliderAnimation: {
          name: 'infiniteSliderAnimation',
          infiniteSliderAnimation: false,
          labelDesc: 'infiniteSliderAnimation',
          callback: function () {
            vm.resources.infiniteSliderAnimation.defaultValue = this.infiniteSlider
            vm.element.internal_config.infiniteSliderAnimation = this.infiniteSlider;
          },
        },
					fixed: {
						name: 'fixed',
						fixed: false,
						fixedMobile: false,
						labelDesc: 'fixed',
						callback: function () {

							vm.resources.fixed.fixed = this.fixedActive;
							vm.element.internal_config.fixed = this.fixedActive;

							vm.resources.fixed.fixedMobile = this.fixedMobileActive;
							vm.element.internal_config.fixedMobile = this.fixedMobileActive;

						},
					},
					backgroundColor: {
						name: 'backgroundColor',
						defaultValue: '#ffffff',
						gradient: true,
						labelDesc: 'bg-color',
						callback: function () {

							vm.resources.backgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.backgroundColor = this.colorValue;
							// vm.element.internal_config.backgroundColor =

						},
					},
					internalBackgroundColor: {
						name: 'internalBackgroundColor',
						defaultValue: '#ffffff',
						gradient: true,
						canRemove: true,
						labelDesc: 'bg-color',
						callback: function () {


							vm.resources.internalBackgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.internalBackgroundColor = this.colorValue;
							// vm.element.internal_config.backgroundColor =

						},
					},
					height: {
						name: 'height',
						defaultValue: '800',
						min: '50',
						max: '7000',
						labelDesc: 'height',
						callback: function () {
							vm.resources.height.defaultValue = this.value;
							vm.element.internal_config.height = this.value + 'px';
						},
					},
					minHeight: {
						name: 'minHeight',
						defaultValue: '50',
						min: '0',
						max: '7000',
						labelDesc: 'minHeight',
						callback: function () {
							vm.resources.minHeight.defaultValue = this.value;
							vm.element.internal_config.minHeight = this.value + 'px';
						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						}
					},
					// boxShadow: {
					// 	name: 'boxShadow',
					// 	defaultValue: '0 0 0 0 black initial',
					// 	min: '0',
					// 	max: '50',
					// 	labelDesc: 'boxShadow',
					// 	callback: function () {
					// 		let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');
					// 		vm.resources.boxShadow.defaultValue = value;
					// 		vm.element.internal_config.boxShadow = value;
					// 	},
					// },
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.borderRadius = value;
						},
					},
					src: {
						defaultValueOrigin: '',
						defaultValueSize: '',
						defaultValueRepeat: '',
						defaultValuePosition: '',
						defaultValueAttachment: '',

						name: 'src',
						defaultValue: '',
						labelDesc: 'bg-image',
						canExternal: true,
						canRemove: true,
						callback: function () {
							vm.resources.src.defaultValue = this.value;
							vm.resources.src.defaultValueOrigin = this.origin;
							vm.resources.src.defaultValueRepeat = this.repeat;
							vm.resources.src.defaultValueSize = this.size;
							vm.resources.src.defaultValuePosition = this.position;
							vm.resources.src.defaultValueAttachment = this.attachment;

							vm.element.internal_config.backgroundImage = this.value;
							vm.element.internal_config.backgroundOrigin = this.origin;
							vm.element.internal_config.backgroundRepeat = this.repeat;
							vm.element.internal_config.backgroundSize = this.size;
							vm.element.internal_config.backgroundPosition = this.position;
							vm.element.internal_config.backgroundAttachment = this.attachment;

							//force apply new bg
							// let color = vm.element.internal_config.backgroundColor;
							// vm.element.internal_config.backgroundColor = '#FFFFFF';
							// vm.element.internal_config.backgroundColor = color;
						},
					},
					internalSrc: {
						name: 'internalSrc',
						defaultValue: '',
						defaultValueOrigin: '',
						defaultValueSize: '',
						defaultValueRepeat: '',
						defaultValuePosition: '',
						defaultValueAttachment: '',
						labelDesc: 'bg-image',
						canExternal: false,
						canRemove: true,
						callback: function () {

							vm.resources.internalSrc.defaultValue = this.value;
							vm.resources.internalSrc.defaultValueOrigin = this.origin;
							vm.resources.internalSrc.defaultValueRepeat = this.repeat;
							vm.resources.internalSrc.defaultValueSize = this.size;
							vm.resources.internalSrc.defaultValuePosition = this.position;
							vm.resources.internalSrc.defaultValueAttachment = this.attachment;

							vm.element.internal_config.internalBackgroundImage = this.value;
							vm.element.internal_config.internalBackgroundOrigin = this.origin;
							vm.element.internal_config.internalBackgroundRepeat = this.repeat;
							vm.element.internal_config.internalBackgroundSize = this.size;
							vm.element.internal_config.internalBackgroundPosition = this.position;
							vm.element.internal_config.internalBackgroundAttachment = this.attachment;

							//force apply new bg
							// let color = vm.element.internal_config.internalBackgroundColor;
							// vm.element.internal_config.internalBackgroundColor = '#FFFFFF';
							// vm.element.internal_config.internalBackgroundColor = color;
						},
					},
					video: {
						name: 'video',
						defaultValue: '',
						defaultValueInternal: false,
						defaultValueAutoplay: false,
						defaultValueMuted: false,
						defaultValueLoop: false,
						labelDesc: 'bg-video',
						canRemove: true,
						callback: function () {

							vm.resources.video.defaultValue = this.value;
							vm.resources.video.defaultValueInternal = this.videoInternal;
							vm.resources.video.defaultValueAutoplay = this.autoplay;
							vm.resources.video.defaultValueMuted = this.muted;
							vm.resources.video.defaultValueLoop = this.loop;

							vm.element.internal_config.video = this.value;
							vm.element.internal_config.videoInternal = this.videoInternal;
							vm.element.internal_config.autoplay = this.autoplay;
							vm.element.internal_config.muted = this.muted;
							vm.element.internal_config.loop = this.loop;

							//force apply new bg
							let video = vm.element.internal_config.video;
							vm.element.internal_config.video = '';
							vm.element.internal_config.video = video;
						},
					},
					hidePanel: {
						name: 'hidePanel',

						defaultHidePanel : false,
						defaultTimeHidePanel: 0,
						labelDesc : 'hidePanel',

						callback: function () {
							vm.resource.hidePanel.defaultTimeHidePanel = this.timeHidePanel;
							vm.resource.hidePanel.defaultHidePanel = this.hidePanel;

							vm.element.internal_config.hidePanel = this.hidePanel
							vm.element.internal_config.timeHidePanel = this.timeHidePanel;

						}
					},
					arrowConfig: {
						name: 'arrowConfig',

						defaultArrowActive: false,
						defaultArrowWidth: 33,
						defaultArrowWidthMobile: 33,
						defaultArrowHeight: 5,
						defaultArrowColor: '#F0F0F0',

						labelDesc: 'arrowConfig',
						canRemove: true,
						callback: function () {

							vm.resources.arrowConfig.defaultArrowActive = this.active;
							vm.resources.arrowConfig.defaultArrowWidth = this.width;
							vm.resources.arrowConfig.defaultArrowWidthMobile = this.widthMobile;
							vm.resources.arrowConfig.defaultArrowHeight = this.height;
							vm.resources.arrowConfig.defaultArrowColor = this.valueColor;

							vm.element.internal_config.arrowActive = this.active;
							vm.element.internal_config.arrowWidth = this.width;
							vm.element.internal_config.arrowWidthMobile = this.widthMobile;
							vm.element.internal_config.arrowHeight = this.height;
							vm.element.internal_config.arrowColor = this.valueColor;

							//force apply new bg
							let color = vm.element.internal_config.backgroundColor;
							vm.element.internal_config.backgroundColor = '#FFFFFF';
							vm.element.internal_config.backgroundColor = color;
						},
					},
				}
			}
		},
		methods: {
			setMinValuesData(resource, value) {
				this.resources[resource].min = parseInt(value);
			},
      setHeight(value){
        this.resources.height.defaultValue = parseInt(value);
      },
			setValuesData(data) {
				this.element = data;

				this.resources.border.defaultValue = data.internal_config.border;
				this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;
				this.resources.internalBackgroundColor.defaultValue = data.internal_config.internalBackgroundColor;
				// this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;
				this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
				this.resources.height.defaultValue = parseInt(data.internal_config.height);
				this.resources.minHeight.defaultValue = parseInt(data.internal_config.minHeight);

				this.resources.src.defaultValue = data.internal_config.backgroundImage;
				this.resources.src.defaultValueOrigin = data.internal_config.backgroundOrigin;
				this.resources.src.defaultValueRepeat = data.internal_config.backgroundRepeat;
				this.resources.src.defaultValueSize = data.internal_config.backgroundSize;
				this.resources.src.defaultValuePosition = data.internal_config.backgroundPosition;
				this.resources.src.defaultValueAttachment = data.internal_config.backgroundAttachment;

				this.resources.internalSrc.defaultValue = data.internal_config.internalBackgroundImage;
				this.resources.internalSrc.defaultValueOrigin = data.internal_config.internalBackgroundOrigin;
				this.resources.internalSrc.defaultValueRepeat = data.internal_config.internalBackgroundRepeat;
				this.resources.internalSrc.defaultValueSize = data.internal_config.internalBackgroundSize;
				this.resources.internalSrc.defaultValuePosition = data.internal_config.internalBackgroundPosition;
				this.resources.internalSrc.defaultValueAttachment = data.internal_config.internalBackgroundAttachment;

				this.resources.arrowConfig.defaultArrowActive = data.internal_config.arrowActive;
				this.resources.arrowConfig.defaultArrowWidth = parseInt(data.internal_config.arrowWidth);
				this.resources.arrowConfig.defaultArrowWidthMobile = parseInt(data.internal_config.arrowWidthMobile);
				this.resources.arrowConfig.defaultArrowHeight = parseInt(data.internal_config.arrowHeight);
				this.resources.arrowConfig.defaultArrowColor = data.internal_config.arrowColor;

				this.resources.hidePanel.defaultHidePanel = data.internal_config.hidePanel;
				this.resources.hidePanel.defaultTimeHidePanel = data.internal_config.timeHidePanel;

				this.resources.anchor.anchorActive = data.internal_config.anchorActive;
				this.resources.anchor.anchorName = data.internal_config.anchorName;

				this.resources.parallax.parallaxActive = data.internal_config.parallaxActive;
				this.resources.parallax.parallaxEffect = data.internal_config.parallaxEffect;
				this.resources.parallax.parallaxSpeed = parseFloat(data.internal_config.parallaxSpeed);

        this.resources.infiniteSliderAnimation.defaultValue = data.internal_config.infiniteSliderAnimation;


				this.resources.fixed.fixed = data.internal_config.fixed;
				this.resources.fixed.fixedMobile = data.internal_config.fixedMobile;

				this.resources.divider.separatorActive = data.internal_config.separatorActive;
				this.resources.divider.separatorEffect = data.internal_config.separatorEffect;

				this.resources.divider.separatorColorsFirst = data.internal_config.separatorColors.first;
				this.resources.divider.separatorColorsSecond = data.internal_config.separatorColors.second;
				this.resources.divider.separatorColorsThird = data.internal_config.separatorColors.third;
				this.resources.divider.separatorColorsFourth = data.internal_config.separatorColors.fourth;

				this.resources.divider.separatorValueCustom = data.internal_config.separatorColors.custom;

				this.resources.divider.separatorValueFirst = data.internal_config.separatorColors.value1;
				this.resources.divider.separatorValueSecond = data.internal_config.separatorColors.value2;
				this.resources.divider.separatorValueThird = data.internal_config.separatorColors.value3;
				this.resources.divider.separatorValueFourth = data.internal_config.separatorColors.value3;

				this.resources.video.defaultValue = data.internal_config.video;
				this.resources.video.defaultValueInternal = data.internal_config.videoInternal;
				this.resources.video.defaultValueAutoplay = data.internal_config.autoplay;
				this.resources.video.defaultValueMuted = data.internal_config.muted;
				this.resources.video.defaultValueLoop = data.internal_config.loop;

			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Panel/Resources.vue